

export default class {
    constructor($el, windowPal) {
        this.$ = $el;
        this.windowPal = windowPal;
        this.modalWindows = [];
        this.currentWindow = null;
        this.isOpen = false;
        $('[data-modal-window]').each((i, el)=>{
            let $window = $(el),
                windowClass = $window.data('modal-window'),
                window;
            switch(windowClass) {
                case 'RegisterVacancy':
                    window = new RegisterVacancy($window, this);
                    break;
                default:
                    window = new ModalWindow($window, this, windowClass);
            }
            if (window) {
                this.modalWindows.push(window);
            }
        });
    }
    click(window) {
        this.isOpen = ! this.isOpen;
        if (this.isOpen) {
            this.open(window);
        } else {
            this.close();
        }
    }
    open(window) {
        this.isOpen = true;
        this.$.addClass('-display');
        if (this.currentWindow !== window) {
            if (this.currentWindow) {
                this.currentWindow.hide();
            }
            this.currentWindow = window;
        }
        setTimeout(()=>{
            this.$.addClass('-opaque');
        }, 10);
        this.windowPal.clickoff(window.$, ()=>{
            this.close();
        });
    }
    close() {
        this.isOpen = false;
        this.$.removeClass('-opaque');
        setTimeout(()=>{
            this.$.removeClass('-display');
        }, 500);
        this.windowPal.resetClickoff();
    }
}


class ModalWindow {
    constructor($el, master, triggerSel = null) {
        this.$ = $el;
        this.master = master;
        if (triggerSel === null) {
            $.each(this.triggers(), (i, $trig)=>{
                // console.log($trig[0]);
                $trig.click(()=>{
                    this.click();
                    return false;
                });
            });
        } else {
            $(triggerSel).click(()=>{
                this.click();
                return false;
            });
        }
    }
    click() {
        this.master.click(this);
        this.$.addClass('-show');
    }
    hide() {
        this.$.removeClass('-show');
    }
}

class RegisterVacancy extends ModalWindow {
    triggers() {
        let trigs = [];
        ['#menu-top-top', '.bottom-fixed-buttons ul'].forEach((selector, i)=> {
            $(selector).find('a').each((j, el)=>{
                let $trig = $(el), href = $trig.attr('href');
                if (typeof href === 'string') {
                    if (href.includes('register-a-vacancy')) {
                        // console.log('found menu links on', i, el);
                        trigs.push($trig);
                    }
                }
            });
        });
        let $classedLinks = $('.register-a-vacancy');
        $classedLinks.each((i, el)=>{
            let $trig = $(el);
            // console.log('found classed link', el);
            trigs.push($trig);
        });
        return trigs;
    }
}





// WEBPACK FOOTER //
// ./scripts/lib/Modal.js